module.exports = __webpack_public_path__ + "static/media/Artemis.be0ac0a4.jpg";